var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-8 font-bold text-3xl"},[_vm._v("Słowniki")])])
}]

export { render, staticRenderFns }